import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import moment from 'moment';
import PublishItem from './PublishItem';

const styles = {
  blue: {
    color: 'rgba(51, 163, 243, 1.0)',
  },
  red: {
    color: 'rgba(243, 83, 83, 1.0)',
  },
  status: {
    fontWeight: 600,
    fontSize: 12,
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
  },
};

class PublishSchedule extends Component {
  render() {
    const { twitterId, fbId, showWeb, showMobile, publishDate, twitterPublish, fbPublish } = this.props;
    const now = moment();
    const date = moment(publishDate);
    const isAfter = now.isAfter(date);
    // Don't show if not published and not scheduled
    if (isAfter) {
      return null;
    }
    return (
      <div className="create-entry-schedule">
        <div className="create-entry-schedule-header clearfix">
          <div className="create-entry-schedule-header-title">Scheduled</div>
          <div className="create-entry-schedule-header-icon">
            <img className="fit-parent" src="/assets/img/icons/schedule.png" alt="" />
          </div>
        </div>
        <div className="create-entry-schedule-content">
          {publishDate &&
            <div>
              <div style={{ ...styles.status }}>{moment(publishDate).format('MMM D YYYY, h:mmA z')}</div>
              <div style={{ ...styles.blue, ...styles.status }}> {moment(publishDate).fromNow()}</div>
            </div>
          }
          <PublishItem title={'Website'} isPublished={showWeb} date={publishDate} />
          <PublishItem title={'Mobile'} isPublished={showMobile} date={publishDate} />
          <PublishItem title={'Twitter'} id={twitterId} isPublished={twitterPublish} date={publishDate} />
          <PublishItem title={'Facebook'} id={fbId} isPublished={fbPublish} date={publishDate} />
        </div>
      </div>
    );
  }
}

PublishSchedule.propTypes = {
  twitterId: PropTypes.string,
  fbId: PropTypes.string,
  showWeb: PropTypes.bool,
  showMobile: PropTypes.bool,
  publishDate: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  twitterPublish: PropTypes.bool,
  fbPublish: PropTypes.bool,
};

const selector = formValueSelector('generic-entry');
function mapStateToProps(state) {
  return {
    showMobile: selector(state, 'show_mobile'),
    showWeb: selector(state, 'show_web'),
    publishDate: selector(state, 'publish_date'),
    twitterPublish: selector(state, 'twitter_publish'),
    fbPublish: selector(state, 'fb_publish'),
    fbId: selector(state, 'fb_id'),
    twitterId: selector(state, 'twitter_id'),
    published: selector(state, 'published'),
  };
}

export default connect(
  mapStateToProps,
)(PublishSchedule);



// WEBPACK FOOTER //
// ./src/cms/entry/blitz/PublishSchedule.js